import * as AuthActionType from '../constants/ActionTypes';

const initialState = {
    loginErr: '',
    loginSuccess: '',
    voucherErr: '',
    voucherSuccess: '',
    captchaL: 0,
    captchaR: 0,
    captchaOperator: '+',
    forgetSuccess: '',
    forgetError: ''
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AuthActionType.LOGIN_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.LOGIN_SUCCESS:
            return {...state, ...action.payload};
        case AuthActionType.RESET_LOGIN_ERR:
            return {...state, loginErr: '', voucherErr: '', voucherSuccess: ''};
        case AuthActionType.VOUCHER_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.VOUCHER_SUCCESS:
            return {...state, ...action.payload};
        case AuthActionType.RESET_CAPTCHA:
            return {...state, ...action.payload};
        case AuthActionType.FORGOT_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.FORGOT_SUCCESS:
            return {...state, ...action.payload};
        case AuthActionType.RESET_FORGET_MSG:
            return {...state, forgetError: '', forgetSuccess: ''};
        default:
            return state;
    }
};
